/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Text } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import BoardUser from 'solis/claude/logic/board/user';
import GalaxyUser from 'solis/claude/logic/galaxy/user';

import Swatch from 'solis/claude/element/user/swatch';


const getUser = ({ board, galaxy, user }) =>
{
  return board ? new BoardUser(board, user) : new GalaxyUser(galaxy, user);
};


const getName = (props) =>
{
  return getUser(props).getName();
};


const Container = styled(Text)`
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
`;


const Name = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
`;


export default ({ board, galaxy, user, size = '1', color = 'gray' }) =>
(
  <Container size = {size} color = {color}>
    <Swatch board = {board} galaxy = {galaxy} user = {user} />
    <Name>{getName({ board, galaxy, user })}</Name>
  </Container>
);
